import * as React from 'react';
import { string, arrayOf, shape } from 'prop-types';
import styled from 'styled-components';
import media from './fpp_media_queries';
import TextComponent from './text_component';
import { color, fontSize } from '@core-ds/primitives';

const List = styled.dl({
   fontSize: fontSize.lg,
   margin: 0,
   columnCount: 2,
   columnGap: 40,

   [media.mobileLandscapeAll]: {
      columnCount: 1,
   },
});

const HeadingContainer = styled.div({
   paddingBottom: 40,
   [media.mobileLandscapeAll]: {
      paddingBottom: 20,
   },
});

const ListHeading = ({ heading }) => (
   <HeadingContainer>
      <TextComponent subheading={heading} />
   </HeadingContainer>
);

const ListItem = styled.div({
   display: 'inline-flex',
   justifyContent: 'space-between',
   alignItems: 'center',
   width: '100%',
   padding: '5px 16px',
   color: color.gray[800],
   minHeight: 55,
   textSizeAdjust: '100%',

   '&:nth-child(2n +1)': {
      backgroundColor: color.gray[50],
   },

   [media.mobileLandscapeAll]: {
      minHeight: 50,
   },

   [media.mobile]: {
      fontSize: 14,
   },
});

const ListTerm = styled.dt({
   display: 'flex',
   alignItems: 'center',
   flex: '0 0 auto',
   maxWidth: '60%',
});

const ListIcon = styled.span({
   marginRight: 14,
   [media.mobileLandscapeAll]: {
      display: 'none',
   },
});

const ListDescription = styled.dd({
   textAlign: 'right',
   whiteSpace: 'pre-line',
   maxWidth: '55%',
   marginLeft: 36,
});

const ListComponent = ({ heading, items }) => (
   <div>
      {heading && <ListHeading heading={heading} />}
      <List>
         {items.map(({ icon, name, description }, index) => (
            <ListItem key={index}>
               <ListTerm>
                  {icon && <ListIcon dangerouslySetInnerHTML={{ __html: icon }} />}
                  {name}
               </ListTerm>
               {description && <ListDescription>{description}</ListDescription>}
            </ListItem>
         ))}
      </List>
   </div>
);

ListComponent.propTypes = {
   items: arrayOf(
      shape({
         icon: string,
         name: string.isRequired,
         description: string,
      })
   ),
};

ListComponent.defaultProps = {
   items: [],
};

export default ListComponent;
